(() => {
  const menus = document.querySelectorAll('[data-cvx-menu]');
  menus.forEach((menu) => {
  const close = () => menu.removeAttribute('open');
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu.open) {
      close();
      menu.querySelector('summary').focus();
    }
  });
  document.addEventListener('pointerdown', (event) => {
    if (menu.open && !menu.contains(event.target)) close();
  });
  menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', close));
  matchMedia('(min-width:901px)').addEventListener('change', close);
  });
})();

(() => {
  const root = document.querySelector('[data-cvx6p]');
  if (!root) return;
  const image = root.querySelector('.cvx6p-main-image');
  if (!image) return;
  const thumbnails = root.querySelectorAll('[data-cvx-image]');
  thumbnails.forEach((thumbnail) => thumbnail.addEventListener('click', () => {
    image.removeAttribute('srcset');
    image.src = thumbnail.dataset.cvxImage;
    image.alt = thumbnail.dataset.cvxAlt || '';
    thumbnails.forEach((item) => item.setAttribute('aria-pressed', String(item === thumbnail)));
  }));
})();
